export default __webpack_public_path__ + "1927bd6869526e4a8a199b658f0b1466.png";